import { Host, h } from "@stencil/core";
import { toFileList } from "../../utils/utils";
function renderHiddenField(data) {
    if (data.value instanceof File) {
        return h("input", { name: data.name, type: "file", class: "hidden-field", files: toFileList(data.value) });
    }
    if (data.value.indexOf("\n") > -1) {
        return h("textarea", { readonly: true, class: "hidden-field", name: data.name }, data.value);
    }
    return h("input", { type: "hidden", name: data.name, value: data.value });
}
export class ApieRenderTypes {
    constructor() {
        this.value = {};
        this.csrfToken = null;
        this.internalState = {};
        this.supportsMultipart = false;
        this.storedMappedFiles = new WeakMap();
        this.date = new Date();
    }
    getHiddenFields() {
        const res = [];
        const todoList = [[this.value, '_apie']];
        let todo;
        while (todo = todoList.pop()) {
            if (todo[0] === null || todo[0] === undefined) {
                res.push({ name: todo[1], value: 'null' });
                continue;
            }
            if (todo[0] instanceof File) {
                res.push({ name: todo[1], value: 'Psr\\Http\\Message\\UploadedFileInterface' });
                continue;
            }
            if (Array.isArray(todo[0])) {
                if (todo[0].length === 0) {
                    res.push({ name: todo[1], value: 'array' });
                }
                todoList.push(...todo[0].map((value, index) => {
                    return [value, todo[1] + '[' + index + ']'];
                }));
                continue;
            }
            switch (typeof todo[0]) {
                case 'boolean':
                    res.push({ name: todo[1], value: todo[0] ? 'true' : 'false' });
                    continue;
                case 'number':
                case 'string':
                case 'bigint':
                    continue;
            }
            const entries = Object.entries(todo[0]);
            todoList.push(...entries.map((subEntry) => {
                return [subEntry[1], todo[1] + '[' + subEntry[0] + ']'];
            }));
            if (entries.length === 0) {
                res.push({ name: todo[1], value: 'object' });
            }
        }
        return res;
    }
    getInternalFields() {
        const res = [];
        const todoList = [[this.internalState, '_internal']];
        let todo;
        while (todo = todoList.pop()) {
            if (todo[0] === null || todo[0] === undefined) {
                continue;
            }
            if (Array.isArray(todo[0])) {
                todoList.push(...todo[0].map((value, index) => {
                    return [value, todo[1] + '[' + index + ']'];
                }));
                continue;
            }
            switch (typeof todo[0]) {
                case 'boolean':
                    continue;
                case 'string':
                    if (todo[0] !== '') {
                        res.push({ name: todo[1], value: String(todo[0]) });
                    }
                    continue;
                case 'number':
                case 'bigint':
                    res.push({ name: todo[1], value: String(todo[0]) });
                    continue;
            }
            const entries = Object.entries(todo[0]);
            todoList.push(...entries.map((subEntry) => {
                return [subEntry[1], todo[1] + '[' + subEntry[0] + ']'];
            }));
        }
        return res;
    }
    getSubmitFields() {
        const res = [];
        const todoList = [[this.value, 'form']];
        let todo;
        while (todo = todoList.pop()) {
            if (todo[0] === null || todo[0] === undefined) {
                continue;
            }
            if (todo[0] instanceof File) {
                if (this.supportsMultipart) {
                    res.push({ name: todo[1], value: todo[0] });
                }
                else {
                    if (this.storedMappedFiles.has(todo[0])) {
                        todo[0] = this.storedMappedFiles.get(todo[0]);
                    }
                    else {
                        const file = todo[0];
                        const reader = new FileReader();
                        reader.addEventListener("load", () => {
                            // convert image file to base64 string
                            this.storedMappedFiles.set(file, {
                                base64: String(reader.result).replace(/^data:[^;]+;base64,/, ''),
                                originalFilename: file.name
                            });
                            setTimeout(() => {
                                this.date = new Date();
                            }, 0);
                        }, false);
                        reader.readAsDataURL(file);
                    }
                }
            }
            if (Array.isArray(todo[0])) {
                todoList.push(...todo[0].map((value, index) => {
                    return [value, todo[1] + '[' + index + ']'];
                }));
                continue;
            }
            switch (typeof todo[0]) {
                case 'boolean':
                    continue;
                case 'number':
                case 'string':
                case 'bigint':
                    res.push({ name: todo[1], value: String(todo[0]) });
                    continue;
            }
            const entries = Object.entries(todo[0]);
            todoList.push(...entries.map((subEntry) => {
                return [subEntry[1], todo[1] + '[' + subEntry[0] + ']'];
            }));
        }
        return res;
    }
    render() {
        return (h(Host, { key: 'eb775af4b3ff6af4ba2ba47215d99811df953240', id: 'a' + String(this.date).replace(/[\s\+\-\(\):]/g, '') }, this.csrfToken && h("input", { key: 'c18f9f0716cb216eabf036b58ba7ac4105b468f3', type: "hidden", name: "_csrf", value: this.csrfToken }), this.getInternalFields().map(renderHiddenField), this.getSubmitFields().map(renderHiddenField), this.getHiddenFields().map(renderHiddenField)));
    }
    static get is() { return "apie-render-types"; }
    static get encapsulation() { return "scoped"; }
    static get originalStyleUrls() {
        return {
            "$": ["apie-render-types.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["apie-render-types.css"]
        };
    }
    static get properties() {
        return {
            "value": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "Record<string, any>",
                    "resolved": "{ [x: string]: any; }",
                    "references": {
                        "Record": {
                            "location": "global",
                            "id": "global::Record"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "{}"
            },
            "csrfToken": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string|null",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "csrf-token",
                "reflect": true,
                "defaultValue": "null"
            },
            "internalState": {
                "type": "unknown",
                "mutable": true,
                "complexType": {
                    "original": "Record<string, any>",
                    "resolved": "{ [x: string]: any; }",
                    "references": {
                        "Record": {
                            "location": "global",
                            "id": "global::Record"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "{}"
            },
            "supportsMultipart": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "supports-multipart",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "storedMappedFiles": {},
            "date": {}
        };
    }
}
//# sourceMappingURL=apie-render-types.js.map
